import {VGNav} from "vgnav";
import {VGLawCookie} from "vglawcookie";
import {VGSelect} from "vgselect";
import {loadLib} from "./utils/loadLib";
import VGFlipList from "./utils/nav/VGFlipList";
import RussianHyphenator, {HYPHENATOR_DEFAULT_OPTIONS} from "./utils/hyphenate";

const VGListener = {
	onReady: () => {
		VG.defaults();
		VG.plugins.init();
		VG.ScrollToTop.init($(window));
		VG.ScrollHeader.init($(window));
		VG.clone();

		// [vegas]
		VG.log();
	},

	onLoad: () => {

	},

	onScroll: ($self) => {
		VG.ScrollHeader.init($self);
		VG.ScrollToTop.setPosition($self);
	},

	onResize: ($self) => {
		VG.clone();
		VG.ScrollHeader.cacheReady = false;
	},
}

const VG = {
	log: function (errors = []) {
		if (!errors.length) {
			console.log("%cVG app was initialization","color: green;");
		} else {
			errors.forEach(function (item) {
				console.error(item);
			});
		}
	},

	defaults: () => {
		// Манипуляции с контентом по умолчанию
		$('.vg-page-default, .page-default').each(function () {
			let $self = $(this);

			// Table
			$self.find('table').each(function () {
				let $table = $(this);
				$table.addClass('table table-bordered');

				if (!$table.parent().hasClass('table-responsive')) {
					$table.wrap('<div class="table-responsive"></div>');
				}
			});

			// image
			$self.find('img').addClass('img-fluid');

			$self.find('a[href=""][data-fancybox] img').each(function(){
				let src = $(this).attr('src');
				if (src) {
					$(this).closest('a').attr('href', src);
				}
			});
		});
	},

	moveCatalogBlock: function (sourceSelector, targetSelector, anchorName, shouldMoveToTarget) {
		let $source = $(sourceSelector).first();
		if (!$source.length) return;

		let $target = $(targetSelector).first();
		if (!$target.length) return;

		let $anchor = $('[data-vg-move-anchor="' + anchorName + '"]').first();
		if (!$anchor.length) {
			$anchor = $('<span hidden data-vg-move-anchor="' + anchorName + '"></span>');
			$source.before($anchor);
		}

		if (shouldMoveToTarget) {
			if (!$target.has($source).length) {
				$target.append($source);
			}
			return;
		}

		if ($anchor.parent().length && $source.prev()[0] !== $anchor[0]) {
			$anchor.after($source);
		}
	},

	clone: () => {
		let shouldMoveToMobile = window.innerWidth < 1200;
		VG.moveCatalogBlock('.catalog-filters--clone', '.catalog-sidebar--clone-filters', 'catalog-filters', shouldMoveToMobile);
		VG.moveCatalogBlock('.catalog-categories--clone', '.catalog-sidebar--clone-categories', 'catalog-categories', shouldMoveToMobile);
	},

	plugins: {
		rollupAutoId: 0,

		init: () => {
			VG.plugins.enableVGSelect();
			VG.plugins.enableVGNav();
			VG.plugins.enableLawCookie();
			VG.plugins.enableVGRollup();
			VG.plugins.enableHyphenator();
		},

		enableHyphenator: function () {
			let hyphenators = document.querySelectorAll('[data-hyphenator]');
			if (hyphenators.length) {
				const hyphenatorDefaults = {
					...HYPHENATOR_DEFAULT_OPTIONS,
					minLeadingFragmentLength: 4,
					minWordLength: 30,
				};

				Array.from(hyphenators).forEach(function (element) {
					const hyphenator = new RussianHyphenator(hyphenatorDefaults);
					hyphenator.processElement(element);
				});
			}
		},

		enableVGNav: function () {
			Array.from(document.querySelectorAll('.vg-nav')).forEach(el => {
				if (el.dataset.vgnavInited === '1') return;
				el.dataset.vgnavInited = '1';

				new VGNav(el, {
					breakpoint: 'md',
						isExpand: true,
						isCollapse: true,
						isHover: true,
						toggle: ''
				}, {
					afterInit: ({ nav, element, settings }) => {
						const $elmSidebar = document.getElementById('vg-nav-sidebar');
						if ($elmSidebar) {
							let $_navigation = $elmSidebar.querySelector('.vg-nav-wrapper');
							if ($_navigation && $_navigation.dataset.vgFlipListInited !== '1') {
								$_navigation.dataset.vgFlipListInited = '1';
								$_navigation.classList.remove('vg-nav-wrapper');

								new VGFlipList($_navigation, {
									target: Array.from($_navigation.querySelectorAll('.dropdown > a'))
								});
							}
						}
					},
				});
			})
		},

		enableVGSelect: function ()  {
			let elements = document.querySelectorAll('select.vg-select');
			for (const element of elements) {
				if (element.dataset.vgselectInited === '1') continue;
				element.dataset.vgselectInited = '1';
				new VGSelect(element)
			}
		},

		enableLawCookie: function () {
			let lawCookie = document.getElementById('vg-lawCookie');
			if (!lawCookie || lawCookie.dataset.vglawcookieInited === '1') return;
			lawCookie.dataset.vglawcookieInited = '1';
			new VGLawCookie();
		},

		enableVGRollup: function () {
			let rollups = Array.from(document.querySelectorAll('[data-rollup-content]'))
				.filter((element) => element.dataset.vgrollupInited !== '1');

			if (!rollups.length) return;

			loadLib.vgrollup().then((VGRollup) => {
				rollups.forEach((rollup) => {
					let target = rollup.getAttribute('id');
					let content = rollup.dataset.rollupContent || 'text';

					if (!target) {
						VG.plugins.rollupAutoId += 1;
						target = 'vg-rollup-' + VG.plugins.rollupAutoId;
						rollup.setAttribute('id', target);
					}

					new VGRollup(target, {
						content: content,
						buttonText: {
							more: 'Подробнее',
							less: 'Свернуть'
						},
					}, {
						afterShow: function () {
							// coming soon
						},
						afterHide: function () {
							// coming soon
						}
					});

					rollup.dataset.vgrollupInited = '1';
				});
			}).catch(function (error) {
				VG.log([error]);
			});
		},
	},

	ScrollHeader: {
		lastScrollTop: 0,
		scrollDelta: 8,
		body: $('body'),
		stickyArea: null,
		sticky: null,
		widgetsSticky: null,
		disabled: false,
		cacheReady: false,
		isScrolled: null,
		isFixed: null,
		widgetsTop: null,

		cacheElements: function () {
			this.sticky = $('.header-wrapper');
			let $stickyArea = $('.sticky-area');
			this.stickyArea = $stickyArea;
			this.widgetsSticky = $('.widgets-sticky, .sticky-top').add($stickyArea);
			this.disabled = !this.sticky.length;
			this.cacheReady = true;
		},

		isConnected: function ($el) {
			return Boolean($el && $el.length && document.contains($el[0]));
		},

		ensureCache: function () {
			if (!this.cacheReady || !this.isConnected(this.sticky)) {
				this.cacheElements();
			}
		},

		init: function ($window) {
			this.ensureCache();
			if (this.disabled) return;
			let $sticky = this.sticky,
				scroll = $window.scrollTop();
			const scrollDiff = Math.abs(scroll - this.lastScrollTop);
			const shouldRecalcDirection = scrollDiff >= this.scrollDelta;

			if (scroll > 0) {
				if (this.isScrolled !== true) {
					this.body.addClass('header--is-scroll');
					$sticky.addClass('scroll');
					this.isScrolled = true;
				}

				if (shouldRecalcDirection && scroll > this.lastScrollTop) {
					if (this.isFixed !== false) {
						$sticky.removeClass('fixed');
						this.body.removeClass('header--is-fixed');
						this.stickyArea.removeClass('fixed');
						this.isFixed = false;
					}
				} else if (shouldRecalcDirection && scroll < this.lastScrollTop) {
					if (this.isFixed !== true) {
						$sticky.addClass('fixed');
						this.body.addClass('header--is-fixed');
						this.stickyArea.addClass('fixed');
						this.isFixed = true;
					}
				}

			} else {
				if (this.isScrolled !== false || this.isFixed !== false) {
					$sticky.removeClass('scroll').removeClass('fixed');
					this.body.removeClass('header--is-scroll header--is-fixed');
					this.stickyArea.removeClass('fixed');
					this.isScrolled = false;
					this.isFixed = false;
				}
			}
			this.lastScrollTop = scroll;

			// widgets-sticky scroll
			let $widgetsSticky = this.widgetsSticky;
			if ($widgetsSticky.length) {
				const targetTop = this.isFixed === true ? 84 : 16;
				if (this.widgetsTop !== targetTop) {
					/*$widgetsSticky.css('top', targetTop);*/
					this.widgetsTop = targetTop;
				}
			}
		},
	},

	ScrollToTop: {
		posActive: 400,
		btn: 'btn-scroll-to-top',

		init: function ($window) {
			let $layoutScrollToTop = $('#' + this.btn);

			if (!$layoutScrollToTop.length) {
				$('body').append('<div class="to-top" id="'+ this.btn +'"><span><i class="fal fa-chevron-up"></i></span></div>')
			}

			this.setPosition($window);

			let $btnScrollToTop = $('#' + this.btn + ' span');
			$btnScrollToTop.off('click.vgScrollToTop').on('click.vgScrollToTop', function () {
				window.scrollTo(0, 0);

				return false;
			});
		},

		setPosition: function ($window) {
			let $sticky = $('#' + this.btn ),
				scroll = $window.scrollTop();

			if (scroll >= this.posActive) {
				$sticky.addClass('is-active');
			} else {
				$sticky.removeClass('is-active');
			}
		}
	}
}


export default VGListener;
